import React from 'react';
import DataTable from 'react-data-table-component';

import { Header } from './Header';
import * as S from './Styles';

export const Layout = ({children}) => (
    <>
        <Header />

        <S.Container>
            {children}
        </S.Container>
    </>
);
